import React from 'react'
import Field from '../common/Field'
import i18n from 'i18n'

const WeFitterDetails = (props) => {
  const sdos = props.data.structured_data_objects
  if (!sdos || sdos.length < 1) return <></>
  const data = sdos[0].data_rows[0]
  const duration = data.duration
  const sampleFrequency = data.sample_frequency
  const sampleCount = data.sample_count

  return (

    <div className='sport-fields'>
      <Field key='duration' title={i18n.t('components.we_fitter.ecg_details.duration')} value={duration} />
      <Field key='sample_frequency' title={i18n.t('components.we_fitter.ecg_details.sample_frequency')} value={sampleFrequency} />
      <Field key='sample_count' title={i18n.t('components.we_fitter.ecg_details.sample_count')} value={sampleCount} />
    </div>

  )
}

export default WeFitterDetails
